import { Pipe, PipeTransform } from '@angular/core'
import { Organisation } from '@app/domain/Organisation'
import { Venue } from '@app/domain/Venue'

@Pipe({
    name: 'serviceName',
})
export class ServiceNamePipe implements PipeTransform {

    transform(
        serviceId: string | null | undefined,
        organisation: Organisation | null | undefined,
        venue: Venue | null | undefined,
        date: Date | null | undefined
    ): string | null {
        if (!serviceId) {
            return 'All Services'
        }
        if (!organisation || !venue || !date) {
            return null
        }
        const services = organisation.coalescedServicesUsedInVenueOnDate(venue, date)
        const match = services.find(({ service }) => {
            return service.id === serviceId
        })
        return match ? match.service.displayName : null
    }
}
